/* Vario Racing – inline quick filters (bike brand / chain pitch / stock / sale / sort) */
(function () {
  'use strict';
  var BRANDS = [
    { id: 'ktm', n: 'KTM', re: /\bktm\b/i },
    { id: 'husqvarna', n: 'Husqvarna', re: /husqvarna|\bhusky\b/i },
    { id: 'gasgas', n: 'GasGas', re: /gas\s?-?gas/i },
    { id: 'yamaha', n: 'Yamaha', re: /yamaha/i },
    { id: 'honda', n: 'Honda', re: /\bhonda\b/i },
    { id: 'kawasaki', n: 'Kawasaki', re: /kawasaki/i },
    { id: 'suzuki', n: 'Suzuki', re: /suzuki/i },
    { id: 'beta', n: 'Beta', re: /\bbeta\b/i },
    { id: 'sherco', n: 'Sherco', re: /sherco/i },
    { id: 'aprilia', n: 'Aprilia', re: /aprilia/i },
    { id: 'swm', n: 'SWM', re: /\bswm\b/i },
    { id: 'fantic', n: 'Fantic', re: /fantic/i },
    { id: 'tm', n: 'TM Racing', re: /\btm[\s-]?racing\b/i }
  ];
  var PITCHES = ['415', '420', '428', '520', '525', '530', '532', '630'];
  var PAGE = 24;
  var cache = {};
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function load(url) {
    if (cache[url]) return cache[url];
    var all = [];
    function page(n) {
      return fetch(url + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var p = j.products || [];
          all = all.concat(p);
          if (p.length === 250 && n < 6) return page(n + 1);
          return all;
        });
    }
    cache[url] = page(1).then(function (list) {
      return list.map(function (p, idx) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/\s*,\s*/);
        var hay = [p.title, tags.join(' '), (p.handle || '').replace(/-/g, ' '), p.product_type || ''].join(' ');
        var pitch = '';
        tags.forEach(function (t) { var m = /^pitch\s*(\d{3})$/i.exec(String(t).trim()); if (m && !pitch) pitch = m[1]; });
        if (!pitch && /chain/i.test(hay)) { var mt = /\b(415|420|428|520|525|530|532|630)\b/.exec(p.title || ''); if (mt) pitch = mt[1]; }
        var fits = BRANDS.filter(function (b) { return b.re.test(hay); }).map(function (b) { return b.id; });
        var price = Infinity, compare = 0, avail = false;
        (p.variants || []).forEach(function (v) {
          var pr = parseFloat(v.price); if (pr < price) price = pr;
          var c = parseFloat(v.compare_at_price || 0); if (c > compare) compare = c;
          if (v.available) avail = true;
        });
        return {
          idx: idx, title: p.title, handle: p.handle, img: p.images && p.images[0] ? p.images[0].src : '',
          price: price === Infinity ? 0 : price, compare: compare, avail: avail,
          sale: compare > price, fits: fits, pitch: pitch, created: Date.parse(p.published_at || p.created_at || 0) || 0,
          multi: (p.variants || []).length > 1
        };
      });
    });
    return cache[url];
  }

  function QF(root) {
    this.root = root;
    this.main = root.closest('[data-vrf-coll-main]') || root.parentNode;
    this.url = root.getAttribute('data-url');
    this.cur = root.getAttribute('data-currency') || 'EUR';
    this.lang = document.documentElement.lang || 'en';
    this.base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
    var q = new URLSearchParams(location.search);
    this.s = {
      bike: q.get('bike') || read('vrfBike') || '',
      pitch: q.get('pitch') || '',
      stock: q.get('stock') === '1',
      sale: q.get('sale') === '1',
      sort: q.get('sort') || ''
    };
    this.shown = PAGE;
    this.bind();
    var self = this;
    var go = function () {
      load(self.url).then(function (items) { self.items = items; self.buildBrands(); self.buildPitches(); self.render(false); })
        .catch(function () { root.querySelectorAll('[data-qf-skel]').forEach(function (x) { x.remove(); }); });
    };
    if (this.active()) go(); else (window.requestIdleCallback || function (f) { setTimeout(f, 400); })(go);
  }

  QF.prototype.active = function () { var s = this.s; return !!(s.bike || s.pitch || s.stock || s.sale || s.sort); };

  QF.prototype.bind = function () {
    var self = this, r = this.root;
    r.addEventListener('click', function (e) {
      var b = e.target.closest('[data-brand]');
      if (b) {
        self.s.bike = b.getAttribute('data-brand');
        store('vrfBike', self.s.bike || null);
        self.update(); return;
      }
      var pc = e.target.closest('[data-pitch]');
      if (pc) { self.s.pitch = pc.getAttribute('data-pitch'); self.update(); return; }
      var t = e.target.closest('[data-tog]');
      if (t) { var k = t.getAttribute('data-tog'); self.s[k] = !self.s[k]; self.update(); return; }
      if (e.target.closest('[data-qf-reset]')) {
        self.s = { bike: '', pitch: '', stock: false, sale: false, sort: '' }; store('vrfBike', null); self.update(); return;
      }
      if (e.target.closest('[data-qf-more]')) { self.shown += PAGE; self.render(true); }
    });
    var sel = r.querySelector('[data-qf-sort]');
    sel.value = this.s.sort;
    sel.addEventListener('change', function () { self.s.sort = sel.value; self.update(); });
    this.syncUI();
  };

  QF.prototype.syncUI = function () {
    var s = this.s, r = this.root;
    r.querySelectorAll('[data-brand]').forEach(function (b) {
      var on = b.getAttribute('data-brand') === s.bike;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
    r.querySelectorAll('[data-pitch]').forEach(function (b) {
      var on = b.getAttribute('data-pitch') === s.pitch;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
    r.querySelectorAll('[data-tog]').forEach(function (t) { t.setAttribute('aria-pressed', !!s[t.getAttribute('data-tog')]); });
    r.querySelector('[data-qf-sort]').value = s.sort;
  };

  QF.prototype.update = function () {
    this.shown = PAGE;
    this.syncUI();
    var q = new URLSearchParams(location.search);
    ['bike', 'pitch', 'stock', 'sale', 'sort'].forEach(function (k) { q.delete(k); });
    if (this.s.bike) q.set('bike', this.s.bike);
    if (this.s.pitch) q.set('pitch', this.s.pitch);
    if (this.s.stock) q.set('stock', '1');
    if (this.s.sale) q.set('sale', '1');
    if (this.s.sort) q.set('sort', this.s.sort);
    var qs = q.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    var self = this;
    if (!this.items) {
      this.root.classList.add('is-busy');
      load(this.url).then(function (items) { self.items = items; self.buildBrands(); self.buildPitches(); self.render(false); });
      return;
    }
    this.render(false);
  };

  QF.prototype.buildBrands = function () {
    var wrap = this.root.querySelector('[data-qf-brands]');
    wrap.querySelectorAll('[data-qf-skel]').forEach(function (x) { x.remove(); });
    if (wrap.querySelector('[data-brand]:not([data-brand=""])')) return;
    var items = this.items, s = this.s, html = '';
    BRANDS.forEach(function (b, i) {
      var n = items.filter(function (p) { return p.fits.indexOf(b.id) > -1; }).length;
      if (!n && s.bike !== b.id) return;
      html += '<button type="button" class="vrf-qf__brand" data-brand="' + b.id + '" aria-pressed="false" style="animation-delay:' + (i * 30) + 'ms"><span>' + b.n + '</span><i>' + n + '</i></button>';
    });
    wrap.insertAdjacentHTML('beforeend', html);
    var bikeBox = this.root.querySelector('.vrf-qf__bike');
    if (bikeBox) bikeBox.hidden = !html;
    this.syncUI();
    var act = wrap.querySelector('.is-active');
    if (act && act.getAttribute('data-brand')) wrap.scrollLeft = act.offsetLeft - 12;
  };

  QF.prototype.buildPitches = function () {
    var box = this.root.querySelector('[data-qf-pitch]');
    if (!box) return;
    var wrap = box.querySelector('[data-qf-pitches]');
    if (wrap.querySelector('[data-pitch]:not([data-pitch=""])')) return;
    var items = this.items, s = this.s, html = '', found = 0, k = 0;
    PITCHES.forEach(function (pt) {
      var n = items.filter(function (p) { return p.pitch === pt; }).length;
      if (!n && s.pitch !== pt) return;
      if (n) found++;
      html += '<button type="button" class="vrf-qf__pitch" data-pitch="' + pt + '" aria-pressed="false" style="animation-delay:' + (k++ * 30) + 'ms"><span>' + pt + '</span><i>' + n + '</i></button>';
    });
    if (found < 2 && !s.pitch) { box.hidden = true; return; }
    wrap.insertAdjacentHTML('beforeend', html);
    box.hidden = false;
    this.syncUI();
    var act = wrap.querySelector('.is-active');
    if (act && act.getAttribute('data-pitch')) wrap.scrollLeft = act.offsetLeft - 12;
  };

  QF.prototype.money = function (v) {
    try { return new Intl.NumberFormat(this.lang, { style: 'currency', currency: this.cur }).format(v); }
    catch (e) { return v.toFixed(2) + ' ' + this.cur; }
  };

  QF.prototype.card = function (p, i, mode) {
    var img = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    var brand = this.s.bike ? BRANDS.filter(function (b) { return b.id === this.s.bike; }, this)[0] : null;
    var tags = '';
    if (!p.avail) tags += '<span class="vrf-qf__tag vrf-qf__tag--out">Sold out</span>';
    else if (p.sale) tags += '<span class="vrf-qf__tag vrf-qf__tag--sale">Sale</span>';
    if (brand && mode === 'fit') tags += '<span class="vrf-qf__tag vrf-qf__tag--fit">Fits ' + brand.n + '</span>';
    if (brand && mode === 'uni') tags += '<span class="vrf-qf__tag vrf-qf__tag--uni">Universal</span>';
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    return '<a class="vrf-card vrf-zoom vrf-qf__card" style="--i:' + (i % PAGE) + '" href="' + this.base + 'products/' + p.handle + '">' +
      '<span class="vrf-card__media">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
      '<span class="vrf-qf__tags">' + tags + '</span></span>' +
      '<span class="vrf-card__title">' + esc(p.title) + '</span>' +
      '<span class="vrf-card__price"><span class="vrf-card__now' + (p.sale ? ' vrf-card__now--sale' : '') + '">' + (p.multi ? 'from ' : '') + this.money(p.price) + '</span>' +
      (p.sale ? '<s class="vrf-card__was">' + this.money(p.compare) + '</s>' : '') + '</span></a>';
  };

  QF.prototype.render = function (append) {
    var s = this.s, r = this.root, self = this;
    r.classList.remove('is-busy');
    var on = this.active();
    this.main.classList.toggle('qf-on', on);
    var res = r.querySelector('[data-qf-results]'), status = r.querySelector('[data-qf-status]');
    res.hidden = !on;
    if (!on || !this.items) { status.hidden = true; return; }

    var list = this.items.filter(function (p) {
      if (s.pitch && p.pitch !== s.pitch) return false;
      if (s.stock && !p.avail) return false;
      if (s.sale && !p.sale) return false;
      return true;
    });
    var cmp = {
      'price-asc': function (a, b) { return a.price - b.price; },
      'price-desc': function (a, b) { return b.price - a.price; },
      'new': function (a, b) { return b.created - a.created; },
      'az': function (a, b) { return a.title.localeCompare(b.title); }
    }[s.sort] || function (a, b) { return a.idx - b.idx; };

    var fit = [], uni = [];
    if (s.bike) {
      list.forEach(function (p) {
        if (p.fits.indexOf(s.bike) > -1) fit.push(p);
        else if (!p.fits.length) uni.push(p);
      });
    } else { fit = list; }
    fit.sort(cmp); uni.sort(cmp);
    var rows = fit.map(function (p) { return [p, 'fit']; });
    if (uni.length) rows.push(['sep']);
    rows = rows.concat(uni.map(function (p) { return [p, 'uni']; }));

    var brand = BRANDS.filter(function (b) { return b.id === s.bike; })[0];
    var total = fit.length + uni.length;
    var txt = '<b>' + total + '</b> ' + (total === 1 ? 'part' : 'parts');
    if (s.pitch) txt += ' in <b>' + s.pitch + ' pitch</b>';
    if (brand) txt += ' for <b>' + brand.n + '</b>' + (uni.length ? ' <span style="opacity:.7">(' + fit.length + ' specific · ' + uni.length + ' universal)</span>' : '');
    r.querySelector('[data-qf-text]').innerHTML = txt;
    status.hidden = false;

    var grid = r.querySelector('[data-qf-grid]');
    var prev = append ? (this.prevShown || 0) : 0;
    var html = '', count = 0;
    for (var i = 0; i < rows.length && count < this.shown; i++) {
      var row = rows[i];
      if (row[0] === 'sep') {
        if (fit.length && count >= prev) html += '<div class="vrf-qf__sep">Universal parts – fit every bike</div>';
        continue;
      }
      if (count >= prev) html += this.card(row[0], count - prev, row[1]);
      count++;
    }
    this.prevShown = count;
    if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
    r.querySelector('[data-qf-empty]').hidden = total > 0;
    r.querySelector('[data-qf-more]').hidden = count >= total;
  };

  function boot() {
    document.querySelectorAll('[data-vrf-qf]').forEach(function (el) {
      if (el.__qf) return;
      el.__qf = new QF(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('vrf:collection-swap', boot);
})();
